export const serviceSEOData = {
  'power-generation': {
    title: 'Power Generation Services | Reliable Energy Solutions',
    description: 'AL-KONDA Group provides comprehensive power generation services including generator supply, installation, maintenance, and energy management solutions across Iraq.',
    keywords: 'power generation, generator services, energy solutions, power supply Iraq, generator maintenance, electrical services'
  },
  'environmental': {
    title: 'Environmental Services | Sustainable Solutions & Waste Management',
    description: 'Professional environmental services including waste management, environmental consulting, pollution control, and sustainability solutions by AL-KONDA Group.',
    keywords: 'environmental services, waste management, sustainability, pollution control, environmental consulting, green solutions Iraq'
  },
  'oil-fuel-supply': {
    title: 'Oil & Fuel Supply Services | Reliable Energy Distribution',
    description: 'AL-KONDA Group offers reliable oil and fuel supply services, petroleum distribution, fuel management, and energy logistics solutions in Iraq.',
    keywords: 'oil supply, fuel distribution, petroleum services, fuel management, energy logistics, oil fuel Iraq'
  },
  'logistics': {
    title: 'Logistics Services | Supply Chain & Transportation Solutions',
    description: 'Comprehensive logistics services including supply chain management, transportation, warehousing, and distribution solutions by AL-KONDA Group.',
    keywords: 'logistics services, supply chain, transportation, warehousing, distribution, freight services Iraq'
  },
  'general-trading': {
    title: 'General Trading Services | Import & Export Solutions',
    description: 'AL-KONDA Group provides general trading services including import/export, procurement, and commercial trading solutions across the Middle East.',
    keywords: 'general trading, import export, procurement services, commercial trading, trading company Iraq'
  },
  'recycling': {
    title: 'Recycling Services | Sustainable Waste Management Solutions',
    description: 'Professional recycling and waste management services promoting sustainability and environmental responsibility by AL-KONDA Group.',
    keywords: 'recycling services, waste recycling, sustainable waste management, environmental recycling, green recycling Iraq'
  }
}
